module.exports = "\r\n.martop20{\r\n    margin-top: 20px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/allert/allert.component.css
// module id = ./src/app/allert/allert.component.css
// module chunks = main